import React from 'react'
import classes from './RecordingPreviewMetaData.css'
import FormattedDate from '../../../../components/FormattedDate'
import SixLeadIcon from 'static/images/six_lead_badge.svg'

export const RecordingPreviewMetaData = props => {
  const {
    bpm,
    recordedAt,
    is6l,
    me,
  } = props

  return (
    <div className={classes.recordingPreviewMetaData}>
      <span className={classes.bpm}>
        {bpm} BPM
      </span>

      <span className={classes.divider}>
        &bull;
      </span>

      <span className={classes.recordingDate}>
        <span className={classes.datePrefix}>
          {'Recorded '}
        </span>
        <FormattedDate
          date={recordedAt}
          fmt="MM/DD"
          overrideSameDay={true}
          overrideLastDay={true}
          me={me}
        />
      </span>

      {is6l &&
        <React.Fragment>
          <span className={classes.divider}>&bull;</span>
          <SixLeadIcon className={classes.sixLIcon} />
        </React.Fragment>
      }
    </div>
  )
}

export default RecordingPreviewMetaData



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/RecordingPreviewMetaData/RecordingPreviewMetaData.jsx